import get from 'lodash.get';

const getSiteData = (rootState) => get(rootState, 'site.siteData', null);

export default getSiteData;
